import { FeatureFlag } from '@ps/web-core-enums';
import type { ClubOptionsResponse } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import useFeature from '@swf/core/hooks/useFeature';
import useRequest from '@swf/core/hooks/useRequest';

import ENDPOINTS from '../constants/endpoints';

type OnAccessibleHandler<T> = (args: T) => void;
type OnRestrictedHandler = () => void;

interface ClubOptionsReply {
  body: ClubOptionsResponse;
}

const usePublicClubsFeatureHandler = <TAccessiblePayload>(
  clubId: number,
  onAccessible: OnAccessibleHandler<TAccessiblePayload>,
  onRestricted: OnRestrictedHandler
) => {
  const request = useRequest();
  const publicClubsEnabled = useFeature(FeatureFlag.PKRHomeGamesJoinAndCreatePublicClubs);

  const validatePublicClubVisibility = (args: TAccessiblePayload) => {
    if (publicClubsEnabled) return onAccessible(args);

    request({
      service: ENDPOINTS.clubOptions,
      http: true,
      body: { clubId }
    })
      .pipe(catchError((err) => of(err)))
      .subscribe(({ body: { clubOptionsReply } }: ClubOptionsReply) =>
        clubOptionsReply?.open ? onRestricted() : onAccessible(args)
      );
  };

  return { validatePublicClubVisibility };
};

export default usePublicClubsFeatureHandler;
